// ─────────────────────────────────────────────────────────────────────────────
// app/lib/store/index.ts
// Yazar: Bilge
//
// Redux store konfigürasyonu. Uygulama genelinde tek bir store kullanılır.
//
// İki ayrı reducer barındırır:
//   1. modal  → UI state: hangi modal'ın açık/kapalı olduğunu tutar
//   2. api    → RTK Query cache: Member, Profile, Project gibi tüm API verileri
//
// baseApi.middleware neden eklendi?
//   RTK Query'nin cache invalidation (önbellek temizleme), polling,
//   ve optimistic update özellikleri bu middleware sayesinde çalışır.
//   Eklenmezse invalidatesTags/providesTags hiçbir şey yapmaz.
// ─────────────────────────────────────────────────────────────────────────────

import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./modalSlice";
import { baseApi } from "../api/baseApi";

export const store = configureStore({
  reducer: {
    modal: modalReducer,                       // UI state — modal açık/kapalı
    [baseApi.reducerPath]: baseApi.reducer,    // API cache — tüm RTK Query verileri
  },
  middleware: (getDefaultMiddleware) =>
    // baseApi.middleware: cache invalidation ve polling için zorunlu
    getDefaultMiddleware().concat(baseApi.middleware),
});

// TypeScript için tip çıkarımı — useAppSelector ve useAppDispatch hook'larında kullanılır
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
